import { SystemProps } from '@chakra-ui/styled-system';

export const hoverOpacityTransition: SystemProps = {
  transition: 'opacity 0.25s ease-out',
  _hover: {
    opacity: 0.78,
  },
};
